import { useQuery } from '@tanstack/react-query';
import { fetchPlayerWallet, fetchPlayerWalletSummary, fetchWalletTransactions, } from '@digiwedge/teetime-api-client';
import { walletKeys } from './queryKeys.js';
export const usePlayerWallet = (isAuthenticated, options = {}) => {
    const includeTransactions = options.includeTransactions ?? true;
    const normalizedSubjectKey = options.subjectKey?.trim() || null;
    const canLoadWallet = isAuthenticated && Boolean(normalizedSubjectKey);
    const querySubjectKey = isAuthenticated
        ? (normalizedSubjectKey ?? 'pending-authenticated-subject')
        : 'anonymous';
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: walletKeys.summary(includeTransactions ? 'full' : 'summaryOnly', querySubjectKey),
        queryFn: async () => {
            if (!includeTransactions) {
                const response = await fetchPlayerWalletSummary();
                if (!response) {
                    throw new Error('Unable to load wallet information.');
                }
                return { wallet: response.wallet, transactions: [] };
            }
            const response = await fetchPlayerWallet();
            if (!response) {
                throw new Error('Unable to load wallet information.');
            }
            const transactionsResponse = await fetchWalletTransactions({ limit: 20 });
            const transactions = Array.isArray(response.transactions) && response.transactions.length > 0
                ? response.transactions
                : transactionsResponse;
            return { wallet: response.wallet, transactions };
        },
        enabled: canLoadWallet,
        staleTime: 2 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
    if (!canLoadWallet) {
        return {
            wallet: null,
            transactions: [],
            loading: false,
            error: null,
            refresh: () => undefined,
        };
    }
    return {
        wallet: data?.wallet ?? null,
        transactions: data?.transactions ?? [],
        loading: isLoading,
        error: error ? (error instanceof Error ? error.message : 'An error occurred') : null,
        refresh: () => void refetch(),
    };
};
//# sourceMappingURL=usePlayerWallet.js.map